"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(require("./Checkbox"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Checkbox/index.js
 ** module id = 823
 ** module chunks = 0
 **/